import api from 'app/api'

export const authService = api.injectEndpoints({
  endpoints: (build) => {
    return {
      login: build.mutation({
        query: (loginArgs) => ({
          url: 'public/login',
          method: 'POST',
          body: loginArgs,
        }),
        invalidatesTags: ['AUTH'],
      }),
      logout: build.mutation({
        query: () => ({
          url: '/logout',
          method: 'PUT',
        }),
        invalidatesTags: ['LOGOUT'],
      }),
      sendResetPasswordMail: build.mutation({
        query: (resetPasswordArgs) => ({
          url: 'public/password/reset',
          method: 'POST',
          body: resetPasswordArgs,
        }),
        invalidatesTags: ['AUTH'],
      }),
      updatePassword: build.mutation({
        query: (args) => ({
          url: `public/password/restore`,
          method: 'POST',
          body: args,
        }),
        invalidatesTags: ['UPDATE_PASSWORD'],
      }),
      register: build.mutation({
        query: (args) => ({
          url: `public/register`,
          method: 'POST',
          body: args,
        }),
        invalidatesTags: ['REGISTER'],
      }),
      registerClient: build.query({
        query: () => ({
          url: `config/register/client`,
          method: 'GET'
        })
      }),
      checkMfa: build.mutation({
        query: (mfaArgs) => ({
          url: 'public/mfa',
          method: 'POST',
          body: mfaArgs,
        }),
        invalidatesTags: ['AUTH'],
      }),
      getToken:build.mutation({
        query: (refreshToken) => ({
          url: 'public/refreshToken',
          method: 'POST',
          body: { refreshToken },
        }),
        invalidatesTags: ['GET_TOKEN'],
      }),
      checkCookieSafe: build.mutation({
        query: (args) => ({
          url: 'public/checkCookieSafe',
          method: 'POST',
          body: args,
        }),
        invalidatesTags: ['CHECK_COOKIE_SAFE'],
      }),
    }
  },
})

export const {
  useLoginMutation,
  useLogoutMutation,
  useRegisterMutation,
  useSendResetPasswordMailMutation,
  useLazyRegisterClientQuery,
  useUpdatePasswordMutation,
  useCheckMfaMutation,
  useGetTokenMutation,
  useCheckCookieSafeMutation,
} = authService
